const actionTypes = {
  GET_SETTINGS: 'userSettings/GET_SETTINGS',
  SET_SAVED_BONUS_SETTINGS: 'userSettings/SET_SAVED_BONUS_SETTINGS',
  CLEAR_SAVED_BONUS_SETTINGS: 'userSettings/CLEAR_SAVED_BONUS_SETTINGS',
};

const getSettings = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.finance.getSettings();
  if (response.success) {
    dispatch({
      type: actionTypes.GET_SETTINGS,
      payload: response.data,
    });
  }
};

const setSavedBonusSettings = ({ bonusAmount, bonusPercentAmount }) => ({
  type: actionTypes.SET_SAVED_BONUS_SETTINGS,
  payload: { bonusAmount, bonusPercentAmount, isEnabled: true },
});

const clearSavedBonusSettings = () => ({
  type: actionTypes.CLEAR_SAVED_BONUS_SETTINGS,
});

export { actionTypes, getSettings, setSavedBonusSettings, clearSavedBonusSettings };
